/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {
  ProjectType,
  projectTypeOfString
}                           from './project.type';
import { ProjectMeta }      from './project.meta';
import { AbstractProject }  from "./abstract.project";

/**
 *
 * @class ProjectFactory
 *
 * @brief generator for projects, for example create a proper project subclass given a
 * serialized JSON string of the valid subclasses.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class ProjectFactory {

  /** create a typed (empty/new) project */
  public static fromType(type: ProjectType, name: string): AbstractProject {

    switch (type) {

      case ProjectType.BatchSimulation: return new ProjectMeta.classNameToCtor['BatchSimulationProject'](name);
      case ProjectType.Simulation:      return new ProjectMeta.classNameToCtor['SimulationProject'](name);
      case ProjectType.Library:         return new ProjectMeta.classNameToCtor['LibraryProject'](name);

    }

    return null;
  }

  /** create a typed project from its serialized JSON */
  public static fromJSON(json: string): AbstractProject {

    const data = JSON.parse(json);
    const type = projectTypeOfString(data.type);

    switch (type) {

      case ProjectType.BatchSimulation: {

        const p = new ProjectMeta.classNameToCtor['BatchSimulationProject']('');
        p.deserialize(json);
        return p;
      }

      case ProjectType.Simulation: {

        const p = new ProjectMeta.classNameToCtor['SimulationProject']('');
        p.deserialize(json);
        return p;
      }

      case ProjectType.Library: {

        const p = new ProjectMeta.classNameToCtor['LibraryProject']('');
        p.deserialize(json);
        return p;
      }
    }

    /* can't determine project type */

    return null;
  }
}
